/* eslint-disable max-lines */
const previewsContent = {
  facebook: [
    {
      title: "Facebook profile picture",
      description: "Facebook profile picture dimensions should be a minimum of 180&times;180 pixels. Make sure your image is pretty large to be displayed properly both on desktop PCs and smartphones.",
      descriptionCrop: `Facebook profile picture dimensions should be a minimum of 180&times;180 pixels. Make sure your image is pretty large to be displayed properly both on desktop PCs and smartphones.`,
      height: 180,
      width: 180,
    },
    {
      title: "Facebook stories",
      description: "Here, you should simply follow the recommended dimensions of 1080&times;1920 pixels. Upload images both from your phone or computer and resize them for free in a second.",
      descriptionCrop: `Here, you should simply follow the recommended dimensions of 1080&times;1920 pixels. Upload images both from your phone or computer and resize them for free in a second.`,
      height: 1920,
      width: 1080,
    },
    {
      title: "Facebook marketplace",
      description: 'Facebook marketplace requires the image resolution of 1200&times;1200 pixel. Convert your images without quality loss.',
      descriptionCrop: `Facebook marketplace requires the image resolution of 1200&times;1200 pixel. Crop your photos without quality loss.`,
      height: 1200,
      width: 1200,
    },
    {
      title: "Facebook link image",
      description: 'Keep Facebook link images between 600&times;315 and 1200&times;630 pixels for better view. Use our ready solutions to resize photos and pictures for free automatically.',
      descriptionCrop: `Keep Facebook link images between 600&times;315 and 1200&times;630 pixels for better view. Use our ready solutions to resize photos and pictures for free automatically.`,
      height: 630,
      width: 1200,
    },
    {
      title: "Facebook image post",
      description: 'Fb post guidelines recommend keeping the image resolution between 600&times;315 and 1200&times;630 pixels.',
      descriptionCrop: `Fb post guidelines recommend keeping the image resolution between 600&times;315 and 1200&times;630 pixels.`,
      height: 630,
      width: 1200,

    },
    {
      title: "Facebook cover photo",
      description: `Ideal cover photo resolution depends on the type of device. For mobile view, it's 640&times;360 while for desktop computer it's 820&times;312 pixels.`,
      descriptionCrop: `Ideal cover photo resolution depends on the type of device. For mobile view, it's 640&times;360 while for desktop computer it's 820&times;312 pixels. `,
      height: 312,
      width: 820,

    },
    {
      title: "Facebook right column",
      description: 'Make sure the resolution of your ads image is 1200&times;1200 pixels. According to stats, it works best of all. Also, ror the right column, you should choose the 1200&times;1200 pixel option.',
      descriptionCrop: `Make sure the resolution of your ads image is 1200&times;1200 pixels. According to stats, it works best of all. Also, ror the right column, you should choose the 1200&times;1200 pixel option.`,
      height: 1200,
      width: 1200,

    },
    {
      title: "Facebook instant articles",
      description: 'The best option for instant article image resolution is 1200&times;1200 pixels.',
      descriptionCrop: `The best option for instant article image resolution is 1200&times;1200 pixels.`,
      height: 1200,
      width: 1200,

    },
    {
      title: "Facebook event image",
      description: 'The ideal resolution for an event image is 1920&times;1005 pixels. Use the ready preset to resize pictures, change your image aspect ratio and to fit your event page.',
      descriptionCrop: `The ideal resolution for an event image is 1920&times;1005 pixels. Use the ready preset to resize pictures, change your image aspect ratio and to fit your event page.`,
      height: 1005,
      width: 1920,
    },
    {
      title: "Facebook group cover",
      description: 'Group cover photo should fit the size of 1640&times;856 pixels. Resize jpg and png pictures for free here.',
      descriptionCrop: `Group cover photo should fit the size of 1640&times;856 pixels. Resize jpg and png pictures for free here.`,
      height: 856,
      width: 1640,
    },
    {
      title: "Facebook highlighted image",
      description: 'The guidelines say the best resolution is 1200&times;717. The tool will automatically resize the image for your highlighted image.',
      descriptionCrop: `The guidelines say the best resolution is 1200&times;717. The tool will automatically resize the image for your highlighted image.`,
      height: 717,
      width: 1200,
    },
    {
      title: "Facebook feed",
      description: 'Make sure your photo fits the dimensions of 1080&times;1350 pixels. If not, you can easily use our free tool to change the size of your jpeg or png image files.',
      descriptionCrop: `Make sure your photo fits the dimensions of 1080&times;1350 pixels. If not, you can easily use our free tool to change the size of your jpeg or png image files.`, 
      height: 1350,
      width: 1080,
    },
  ],


  youtube: [

    {
      title: "YouTube profile picture",
      description: `The best option for YT main pic is 800&times;800 pixels. `,
      descriptionCrop: `The best size option for YouTube profile pic is 800&times;800 pixels. `,
      height: 800,
      width: 800,

    },
    {
      title: "YouTube display ads",
      description: 'For YT display ads, the guidelines recommend keeping the 300&times;250 pixel width and height. ',
      descriptionCrop: `For the display ads, the guidelines recommend keeping the 300&times;250 pixel resolution. `,
      height: 250,
      width: 300,

    },
    {
      title: "YouTube banner",
      description: 'Ideal YT banner resolution is 2560&times;1440. Please make sure your original pic is larger. The tool doesn`t increase the resolution of your photo.',
      descriptionCrop: `Perfect YouTube banner resolution is 2560&times;1440. Please make sure your original image is large enough. The online service doesn't increase the resolution of an image.`,
      height: 1440,
      width: 2560,

    },
    {
      title: "YouTube companion banner ads",
      description: 'YT companion banner ads parameters: 300&times;60 pixels. It will be displayed on your video so that a viewer can click on it.',
      descriptionCrop: `The companion banner ads parameters: 300&times;60 pixels. The banner is displayed on a video so that a viewer can click on it.`,
      height: 60,
      width: 300,

    },
    {
      title: "YouTube Channel Art TV",
      description: 'The recommended YT channel art resolution for watching on TV is 2560&times;1440 pixels.',
      descriptionCrop: `The recommended channel art resolution for TV is 2560&times;1440 pixels.`,
      height: 1440,
      width: 2560,

    },
    {
      title: "YouTube Channel Art desktop",
      description: 'For best viewing experince on desktop, convert your pic resolution to 2560&times;423 px.',
      descriptionCrop: `For desktop viewers, crop your pic dimensions to 2560&times;423 px.`,
      height: 423,
      width: 2560,

    },
    {
      title: "YouTube thumbnail size",
      description: 'Crete YT thumbnail with the dimensions of 1280&times;720. You can also crop the unwanted parts of the pic if necessary. ',
      descriptionCrop: `Use YouTube thumbnail with the dimensions of 1280&times;720. Crop the unwanted image parts if necessary. `,
      height: 720,
      width: 1280,
    },
    {
      title: "YouTube overlay ads",
      description: 'Overlay ads should follow the specs: 480&times;60 pixels. By clicking on it, the viewer will see yoyr website landing page.',
      descriptionCrop: `Overlay ads should follow the parameters: 480&times;60 pixels. By clicking on it, the viewer will be redirected to your website landing page.`,
      height: 60,
      width: 480,
    },
    {
      title: "YouTube Channel Art tablet",
      description: 'If your viewers mostly use tablet to watch your videos, keep the channel art dimensions at 1855&times;423 px.',
      descriptionCrop: `For viewers who use tablet for watching videos, keep the channel art resolution at 1855&times;423.`,
      height: 423,
      width: 1855,
    },
    {
      title: "YouTube Channel Art mobile",
      description: "For mobile users, the perfect option fot channel art is 1546&times;423. However, please not that it won't look good on larger devices such as TV or desktop.",
      descriptionCrop: `For mobile users, the perfect size for channel art is 1546&times;423. However, please keep in mind that it won't look good on larger devices such as TV or desktop.`,
      height: 423,
      width: 1546,
    },
  ],


  instagram: [
    {
      title: "Instagram Profile Pic Size",
      description: 'The Instagram profile image should be 320&times;320 pixels. Since Instagram cuts the image and turns it in a round one, make sure the main part of your image is in the center.',
      descriptionCrop: `The Instagram profile image should be 320&times;320 pixels. Since Instagram cuts the image and turns it in a round one, make sure the main part of your image is in the center.`,
      height: 320,
      width: 320,
    },
    {
      title: "Instagram ad square",
      description: 'The right size for the square format is 1080&times;1080 pixels. Your square ad photos should also be optimized at 1080&times;1080 pixels. ',
      descriptionCrop: `Your square ad photos should be optimized at 1080&times;1080 pixels. `,
      height: 1080,
      width: 1080,
    },
    {
      title: "Instagram ad portrait",
      description: 'The Ad portrait image should fit the specs of 1080&times;1350 pixels.',
      descriptionCrop: `The Ad portrait image should fit the specs of 1080&times;1350 pixels.`,
      height: 1350,
      width: 1080,
    },
    {
      title: "Instagram reels",
      description: 'The most commonly used video ratio of stories and reels is 9:16 with an image size of 1080&times;1920 pixels. You can easily resize jpg and png pictures for free with our tool.',
      descriptionCrop: `The most commonly used video ratio of reels is 9:16 with an image size of 1080&times;1920 pixels. You can easily resize jpg and png pictures for free with our tool.`,
      height: 1920,
      width: 1080,
    },
    {
      title: "Instagram square size",
      description: 'The right size for the square format is 1080&times;1080 pixels. Your square ad photos should also be optimized at 1080&times;1080 pixels. ',
      descriptionCrop: `The right size for the square format is 1080&times;1080 pixels. `,
      height: 1080,
      width: 1080,
    },
    {
      title: "Instagram stories",
      description: 'The most commonly used video ratio of stories and reels is 9:16 with an image size of 1080&times;1920 pixels.',
      descriptionCrop: `The most commonly used video ratio of stories is 9:16 with an image size of 1080&times;1920 pixels.`,
      height: 1920,
      width: 1080,
    },
    {
      title: "Instagram post size",
      description: 'The regular post needed to be sized to 1080&times;1350 pixels.',
      descriptionCrop: `The regular post needed to be sized to 1080&times;1350 pixels.`,
      height: 1350,
      width: 1080,
    },
    {
      title: "Instagram landscape post",
      description: 'Recommended landscape image size for this social network is 1080&times;566 pixels.',
      descriptionCrop: `Recommended landscape image size for this social network is 1080&times;566 pixels.`,
      height: 566,
      width: 1080,
    },
    {
      title: "Instagram portrait post",
      description: 'The preferred resolution for portrait post is 1080&times;1350 pixels.',
      descriptionCrop: `The preferred resolution for portrait post is 1080&times;1350 pixels.`,
      height: 1350,
      width: 1080,
    },
    {
      title: "Instagram landscape ads",
      description: 'Keep in mind that 1080&times;566 pixels size is also ideal for landscape image ads.',
      descriptionCrop: `Keep in mind that 1080&times;566 pixels size is also ideal for landscape image ads.`,
      height: 566,
      width: 1080,
    },
    {
      title: "Instagram IGTV cover",
      description: 'For the IGTV cover, you should resize the image to 420&times;654 pixels. ',
      descriptionCrop: `For the IGTV cover, you should crop pictures, photos and images to 420&times;654 pixels.`,
      height: 654,
      width: 420,
    },
  ],

  twitter: [
    {
      title: "Twitter profile picture size",
      description: 'Twitter pfp should be kept at a maximum of 400&times;400 px.',
      descriptionCrop: `Twitter profile image should be cropped at a maximum of 400&times;400 px.`,
      height: 400,
      width: 400,
    },
    {
      title: "Twitter conversation card",
      description: 'Twitter conversation card are perfect if they follow 800&times;418 px size. ',
      descriptionCrop: `For Twitter conversation card, follow 800&times;418 px resolution. `,
      height: 418,
      width: 800,
    },
    {
      title: "Twitter fleets images",
      description: 'If you want to use fleets images for your brand, make sure to resize them to 1080&times;1920.',
      descriptionCrop: `If you want to use fleets images for your brand, make sure to resize them to 1080&times;1920.`,
      height: 1920,
      width: 1080,
    },
    {
      title: "Twitter banner size",
      description: 'For banner, upload the image that fits the specs of 1500&times;500.',
      descriptionCrop: `For Twitter banner, follow the specs of 1500&times;500.`,
      height: 500,
      width: 1500,
    },
    {
      title: "Twitter website card ad",
      description: 'For a website card image, stick to 800&times;800 px specs.',
      descriptionCrop: `For a website card image, stick to 800&times;800 px specs.`,
      height: 800,
      width: 800,
    },
    {
      title: "Twitter card image (min)",
      description: 'The minimum Twitter card image parameters are 120&times;120. ',
      descriptionCrop: `The minimum Twitter card image parameters are 120&times;120. `,
      height: 120,
      width: 120,

    },
    {
      title: "Twitter direct message",
      description: 'In case you need to send an image in a direct message, to prevent quality loss, resize it to 800&times;418 and save it in png or jpg file format ',
      descriptionCrop: `If you want to send a photo in a direct message, crop the image to 800&times;418 to prevent quality loss. `,
      height: 418,
      width: 800,

    },
    {
      title: "Twitter post image",
      description: 'The best option for Twitter post image is 1200&times;675. Resize images to these specs to get more clicks. ',
      descriptionCrop: `The best size for Twitter post image is 1200&times;675. Crop images to fit these requirements. `,
      height: 676,
      width: 1200,
    },
    {
      title: "Twitter app card ad",
      description: 'Twitter app card ads need to follow the 800&times;800 pixel resolution.',
      descriptionCrop: `The app card ads need to be cropped to 800&times;800 resolution.`,
      height: 800,
      width: 800,
    },
    {
      title: "Twitter carousels",
      description: 'Twitter carousels should be within 800&times;800 px. Keep these specs and let your creativity flow. ',
      descriptionCrop: `Twitter carousels require the size of 800&times;800 px.`,
      height: 800,
      width: 800,
    },
    {
      title: "Twitter video thumbnail",
      description: 'To get more from video thumbnail, try resizing thumbnail images to 640&times;360. ',
      descriptionCrop: `To get more from video thumbnail, try resizing thumbnail images to 640&times;360. `,
      height: 360,
      width: 640,
    },
  ],

  linkedin: [
    {
      title: "LinkedIn logo size",
      description: 'According to Linkedin guidelines, the perfect logo specs are 300&times;300. Make sure your photo fits this resolution before posting. ',
      descriptionCrop: `According to Linkedin guidelines, the perfect logo specs are 300&times;300. Make sure your photo fits this resolution before posting. `,
      height: 300,
      width: 300,
    },
    {
      title: "LinkedIn background photo",
      description: 'The background photo should not be larger than 1584&times;396. Crop the background photos easily without losing quality.',
      descriptionCrop: `The background photo should not be larger than 1584&times;396. Crop the background photos easily without losing quality.`,
      height: 396,
      width: 1584,
    },
    {
      title: "LinkedIn link post",
      description: 'If you want to share a link post with an image, use the 1200&times;627 image parameters. The original quality will be saved.',
      descriptionCrop: `If you want to share a link post with an image, use the 1200&times;627 image parameters. The original quality will be saved.`,
      height: 627,
      width: 1200,
    },
    {
      title: "LinkedIn stories",
      description: 'The ideal image for LinkedIn stories is 1080&times;1920. You may use these parameters both for video and pics,',
      descriptionCrop: `The ideal image for LinkedIn stories is 1080&times;1920. You may use these parameters both for video and pics,`,
      height: 1920,
      width: 1080,

    },
    {
      title: "LinkedIn life tab image",
      description: 'The life tab image can show the info about your business. Keep its dimensions at 1128&times;376.',
      descriptionCrop: `The life tab image can show the info about your business. Keep its dimensions at 1128&times;376.`,
      height: 376,
      width: 1128,
    },
    {
      title: "LinkedIn profile picture",
      description: 'LinkedIn pfp should follow the 1:1 aspect ratio. The minimum image specs are 400&times;400. ',
      descriptionCrop: `LinkedIn pfp should follow the 1:1 aspect ratio. The minimum image specs are 400&times;400. `,
      height: 400,
      width: 400,

    },
    {
      title: "LinkedIn cover photo",
      description: 'Cover photo should bring attention to your business. Create an eye-catching image with the following specs: 1128&times;191',
      descriptionCrop: `Cover photo should bring attention to your business. Create an eye-catching image with the following specs: 1128&times;191`,
      height: 191,
      width: 1128,

    },
    {
      title: "LinkedIn blog post link",
      description: 'For LinkedIn blog post link, apply an image equivalent to 1200&times;627 px.',
      descriptionCrop: `For LinkedIn blog post link, apply an image equivalent to 1200&times;627 px.`,
      height: 627,
      width: 1200,

    },
    {
      title: "LinkedIn square post",
      description: 'The square post for LinkedIn should be customized to 1200&times;1200 width and height. ',
      descriptionCrop: `The square post for LinkedIn should be customized to 1200&times;1200 width and height. `,
      height: 1200,
      width: 1200,

    },
    {
      title: "LinkedIn dynamic ad",
      description: 'Convert images to JPG or PNG format and use 100&times;100 px resolution for a dynamic ad.',
      descriptionCrop: `Convert images to JPG or PNG format and use 100&times;100 px resolution for a dynamic ad.`,
      height: 100,
      width: 100,

    },
    {
      title: "LinkedIn sponsored content",
      description: 'When creating sponsored content, stick to 1200&times;627 px.',
      descriptionCrop: `When creating sponsored content, stick to 1200&times;627 px.`,
      height: 627,
      width: 1200,
    },
    {
      title: "LinkedIn business banner",
      description: 'For business banner, upload an image that is 646&times;220 px.',
      descriptionCrop: `For business banner, upload an image that is 646&times;220 px.`,
      height: 627,
      width: 1200,

    },
    {
      title: "LinkedIn portrait post",
      description: 'LinkedIn portrait post needs to be converted to 1080&times;1350 pixels.',
      descriptionCrop: `LinkedIn portrait post needs to be converted to 1080&times;1350 pixels.`,
      height: 1350,
      width: 1080,

    },
  ],

  google: [
    {
      title: "Google Display skyscraper",
      description: 'Google Display Skyscraper specs are 120&times;600 pixels. Please upload high-quality pic without image distortion.',
      descriptionCrop: `Google Display Skyscraper specs are 120&times;600 pixels. Please upload high-quality pic without image distortion.`,
      height: 600,
      width: 120,

    },
    {
      title: "Google Display leaderboard",
      description: 'Customize Display Leaderboard ad at 728&times;90 px. Although, the pic is not large, you may still use it well to promote your goods. ',
      descriptionCrop: `Customize Display Leaderboard ad at 728&times;90 px. Although, the pic is not large, you may still use it well to promote your goods. `,
      height: 90,
      width: 728,

    },
    {
      title: "Google Display mobile banner",
      description: 'Use free online app to customize your mobile banner ad at  300&times;50.',
      descriptionCrop: `Use free online app to customize your mobile banner ad at 300&times;50.`,
      height: 50,
      width: 300,

    },
    {
      title: "Google Display banner",
      description: 'Resizing your display banner to 468&times;60, will help you promote your website and grab attention. ',
      descriptionCrop: `Cropping your display banner to 468&times;60, will help you promote your website and grab attention. `,
      height: 60,
      width: 468,

    },
    {
      title: "Google Display portrait",
      description: 'Keep the display portrait ad at 300&times;1050. You may crop the image with free online tool and save a new file to post on a website.',
      descriptionCrop: `Keep the display portrait ad at 300&times;1050. You may crop the image with free online tool and save a new file to post on a website.`,
      height: 1050,
      width: 300,

    },
    {
      title: "Google Display vertical rectangle",
      description: 'Google Display Vertical rectangle should be kept at 240&times;400 pixels.',
      descriptionCrop: `Google Display Vertical rectangle should be kept at 240&times;400 pixels.`,
      height: 400,
      width: 240,

    },
    {
      title: "Google Display half banner",
      description: 'The half banner specs are 234&times;60. Make it colorful and noticable. ',
      descriptionCrop: `The half banner specs are 234&times;60. Make it colorful and noticable. `,
      height: 60,
      width: 234,

    },
    {
      title: "Google Display small square",
      description: 'Google Display small square ad recommended resolution is 200&times;200. Use our free online tools to convert your image to necessary parameters. ',
      descriptionCrop: `Google Display small square ad recommended resolution is 200&times;200. Use our free online tools to convert your image to necessary parameters. `,
      height: 200,
      width: 200,

    },
    {
      title: "Google Display wide skyscraper",
      description: 'The wide skyscraper ad best parameters are 160x600. Convert images to new height and width with Image Resizer.',
      descriptionCrop: `The wide skyscraper ad best parameters are 160x600. Convert images to new height and width with Image Cropper.`,
      height: 600,
      width: 160,

    },
    {
      title: "Google Display large leaderboard",
      description: 'The large leaderboard ad optimal specs are 970&times;90.',
      descriptionCrop: `The large leaderboard ad optimal specs are 970&times;90. `,
      height: 90,
      width: 970,

    },
    {
      title: "Google Display large mobile",
      description: 'To use the large mobile ad, convert images to 320&times;50. ',
      descriptionCrop: `To use the large mobile ad, crop images to 320&times;50. `,
      height: 50,
      width: 320,

    },
    {
      title: "Google Display top banner",
      description: 'Ensure your top banner ad fits 930&times;180 px before placing it on the website.',
      descriptionCrop: `Ensure your top banner ad fits 930&times;180 px before placing it on the website.`,
      height: 180,
      width: 930,

    },
    {
      title: "Google Display large mobile",
      description: 'Large mobile ads are perfect if your audience mostly use smartphones and tablets. The recommended specs are 320&times;100.',
      descriptionCrop: `Large mobile ads are perfect if your audience mostly uses smartphones and tablets. The recommended specs are 320&times;100.`,
      height: 100,
      width: 320,

    },
    {
      title: "Google Display panorama",
      description: 'Set the panorama ads specs to 980&times;120 for better results. ',
      descriptionCrop: `Set the panorama ads specs to 980&times;120 for better results. `,
      height: 120,
      width: 980,

    },
    {
      title: "Google Display billboard",
      description: 'Make sure your display billboard ad is within 970&times;250. ',
      descriptionCrop: `Make sure your display billboard ad is within 970&times;250.`,
      height: 250,
      width: 970,

    },
    {
      title: "Google Display square",
      description: 'Display square ad resolution is 250&times;250 px. Make sure the text is as visible as possible.',
      descriptionCrop: `Display square ad resolution is 250&times;250 px. Make sure the text is as visible as possible.`,
      height: 250,
      width: 250,

    },
    {
      title: "Google Display medium rectangle",
      description: 'The medium rectangle ad optimum specs are 300&times;250 px. ',
      descriptionCrop: `The medium rectangle ad optimum specs are 300&times;250 px. `,
      height: 250,
      width: 300,

    },
    {
      title: "Google Display netboard",
      description: 'The Display netboard are perfect if you want to merge several images and animations. You should keep them at 580&times;400.',
      descriptionCrop: `The Display netboard are perfect if you want to merge several images and animations. You should keep them at 580&times;400.`,
      height: 400,
      width: 580,

    },
    {
      title: "Google Display half-page ad",
      description: 'Create unforgettable half-page ad with a resolution of 300&times;600. ',
      descriptionCrop: `Create unforgettable half-page ad with a resolution of 300&times;600. `,
      height: 600,
      width: 300,

    },
    {
      title: "Google Display triple widescreen",
      description: 'The triple widescreen ad ideal resolution is 250&times;360 px. Use it to promote in European countries. ',
      descriptionCrop: `The triple widescreen ad ideal resolution is 250&times;360 px. Use it to promote in Europe. `,
      height: 360,
      width: 250,

    },
    {
      title: "Google Display inline rectangle",
      description: 'If yotu want to place an ad at the end of the post, better use the inline rectangle ad and set the parameters to 300&times;250.',
      descriptionCrop: `If you want to place an ad at the end of the post, better use the inline rectangle ad and set the parameters to 300&times;250.`,
      height: 250,
      width: 300,

    },
    {
      title: "Google Display large rectangle",
      description: 'Resize images to 336&times;280 for large rectangle ads.',
      descriptionCrop: `Crop images to 336&times;280 for large rectangle ads.`,
      height: 280,
      width: 336,

    },
  ],
}

export default previewsContent;